












import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwBannerCard } from '@/shared/banner-card-with-button';
import BetaSignupForm from './beta-signup-form.vue';
// import { RootStoreState } from '@/store';
// import { State } from 'vuex-class';

const cssPrefix = 'available-services';

@Component({
  components: {
    ...UUIFComponents,
    // SwCardView,
    MswAppTitle,
    SwBannerCard,
    BetaSignupForm,
  },
})

export default class BetaProgram extends SwExtendedVue {
  cssPrefix = cssPrefix;
  betaProgram: any = [];
  isForm: boolean = true;
  betaSoftwareData: any = {
    id: '',
    groupID: '',
    title: '',
    version: '',
    betaSwId: '',
  };
  getAllBetaProgram() {
    this.$store.dispatch('BetaProgramStoreModule/getBetaProgrqam', this.$store.getters.getUserId)
    .then((res: any) => {
      this.$store.commit('stopLoading');
      res.content.getBetaProgramDetail.forEach((item:any) => {
        this.betaProgram.push({
          ...item,
          buttonLable: item.isSurveyAlreadyTaken ? 'accessProduct' : 'SignUp',
          imageURL: item.logo !== '' ? item.logo : 'https://www.mysonicwall.com/images/noimagebeta.png',
          applicationName: item.dispBetaName,
          desc: item.description,
        });
      });
    });
  }
  goToServices(data: any) {
    this.betaSoftwareData.id = data.surverServiceProductId;
    this.betaSoftwareData.groupID = data.swGroupId;
    this.betaSoftwareData.title = data.betaName;
    this.betaSoftwareData.version = data.latestVersion;
    this.betaSoftwareData.betaSwId = data.betaSwId;
    this.isForm = !this.isForm;
  }
  mounted() {
    this.getAllBetaProgram();
  }
}
